import { getUser, login } from '../../lib/api';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';

// The `actions` attribute replaces the deprecated `role` attribute (which will
// eventually return an empty list for all users). Mapping:
//   PORTAL_ADMIN -> muni.portal.manage
//   PORTAL_USER  -> muni.portal.member
const PORTAL_MANAGE_ACTION = 'muni.portal.manage' // replaces PORTAL_ADMIN
const PORTAL_MEMBER_ACTION = 'muni.portal.member' // replaces PORTAL_USER
const PORTAL_ACTIONS = [PORTAL_MANAGE_ACTION, PORTAL_MEMBER_ACTION]

// Deprecated legacy role values, kept as a fallback during the transition.
const PORTAL_ROLES = ['PORTAL_USER', 'PORTAL_ADMIN']

// Prefer the new `actions` attribute and fall back to the deprecated `role`, so
// login works both before and after the backend empties out `role`.
const hasPortalAccess = user =>
	(Array.isArray(user.actions) &&
		PORTAL_ACTIONS.some(a => user.actions.includes(a))) ||
	(Array.isArray(user.role) &&
		PORTAL_ROLES.some(r => user.role.indexOf(r) >= 0))

const isPortalAdmin = user =>
	(Array.isArray(user.actions) &&
		user.actions.includes(PORTAL_MANAGE_ACTION)) ||
	(Array.isArray(user.role) && user.role.includes('PORTAL_ADMIN'))

export const setAuth = auth => async dispatch =>
	dispatch({
		type: LOGIN_SUCCESS,
		auth,
	});

/**
 * Login user using session cookies
 *
 * @param {object} credentials
 * @return {object} - server response
 */
export const loginUser = credentials => async (dispatch) => {
	const json = await login(credentials);

	if (json.error) {
		dispatch({
			type: LOGIN_FAILURE,
		});
		return json;
	}

	// Get the rachio user object from their id and token
	const { user } = await getUser(json);
	
	// Check if user object grants portal access (via actions, or legacy role)
	if (!hasPortalAccess(user)) {
		dispatch({
			type: LOGIN_FAILURE,
		})
		return {
			error: true
		}
	}

	// add their role to the auth object
	const role = isPortalAdmin(user) ? 'ADMIN' : 'USER'
	const auth = { ...json, role }
	
	// For use after page reload or separate tabs
	localStorage.setItem('auth', JSON.stringify(auth, null, 2));

	dispatch({
		type: LOGIN_SUCCESS,
		auth
	});
	return json;
};


/**
 * Logout user from session
 */
export const logoutUser = () => async (dispatch) => {
	localStorage.removeItem('auth');
	return dispatch({
		type: LOGOUT,
	});
};
